import { Field } from 'formik';
import ErrorShow from './ErrorShow';
import styles from './fields.css';
import { FormLabel } from './FormLable/FormLabel';
import React, { useState } from 'react';

export const SelectField = ({
  name,
  label,
  options = [], // [{value: 'option1', label: 'گزینه ۱'}, {value: 'option2', label: 'گزینه ۲'}]
  errors = {},
  touched = {},
  className = '',
  twoItemInOneRow = false,
  placeholder = 'انتخاب کنید...',
  isDisabled = false,
  multiple = false,
  onChange,
  size = 4, // برای حالت multiple، تعداد آیتم‌های قابل مشاهده
  ...fieldProps
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasError = errors[name] && touched[name];

  const containerClassName = `form-group ${twoItemInOneRow ? styles['two-in-one-row'] : ''}`;
  const selectClassName = `select-field ${className} ${hasError ? 'is-invalid' : ''} ${isDisabled ? 'disabled' : ''}`;
  const handleSelectClick = () => {
    if (!isDisabled && !multiple) {
      setIsOpen(!isOpen);
    }
  };

  const handleSelectBlur = (e) => {
    setIsOpen(false); // بستن وقتی focus از دست میره
    if (e.target.onBlur) {
      e.target.onBlur(e);
    }
  };
  return (
    <div className={containerClassName}>
      <FormLabel name={name} label={label} />

      <Field name={name}>
        {({ field }) => (
          <div className='select-container' dir='rtl'>
            <select
              id={name}
              name={field.name}
              value={field.value || (multiple ? [] : '')}
              onChange={(e) => {
                field.onChange(e);
                onChange(e);
              }}
              onBlur={handleSelectBlur}
              onClick={handleSelectClick}
              disabled={isDisabled}
              multiple={multiple}
              size={multiple ? size : undefined}
              className={selectClassName}
              {...fieldProps}
            >
              {/* نمایش placeholder فقط در حالت single select */}
              {!multiple && (
                <option value='' disabled>
                  {placeholder}
                </option>
              )}

              {options.map((option, index) => (
                <option key={option.value || index} value={option.value} disabled={option.disabled || false}>
                  {option.label}
                </option>
              ))}
            </select>

            {/* آیکون dropdown برای single select */}
            {!multiple && (
              <span className={`select-arrow ${isOpen ? 'is-open' : ''}`}>
                <svg width='12' height='8' viewBox='0 0 12 8' fill='none'>
                  <path d='M1 1L6 6L11 1' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
              </span>
            )}
          </div>
        )}
      </Field>

      <ErrorShow errors={errors} touched={touched} name={name} />
    </div>
  );
};
